import { createApp } from 'vue'
import App from '@/App.vue'
import { init } from '@/init'
import { registerAuthUi } from '@/ui/registerAuthUi'
import '@/styles/tailwind.css'
import '@/styles/flags.css'
import '@/styles/tailwindRtl.css'
import '@/styles/main.scss'
import 'vue-multiselect/dist/vue-multiselect.css'

import { cc3FunctionalPlugin } from '@coralclub/core'

const app = createApp(App)

// Плагин нужен только для упрощённой регистрации (@coralclub/user → account/register).
// Остальная регистрация по-прежнему ходит в Bitrix через /restApi/* (src/api/http.ts).
//
// auth-3 живёт в среде Coral 2.0 (Bitrix): API 3.0 только через прокси хоста приложения.
// isBitrix → baseURL `/restApi/proxyCC4/` (session → auth/session, register → account/register).
// Не включать isDev: он выше по приоритету и бьёт напрямую в api-develop / api.coral.club.
app.use(cc3FunctionalPlugin, {
  isBitrix: true,
  // auth-3 не ходит в /api/translate — своих словарей CC3 тут нет
  translate: { readApi: false },
})

;(async () => {
  registerAuthUi(app)
  await init(app)
  app.mount('#app')
})()
